export const jobStatusMixin = {
  methods: {
    getJobStatusMixin(status) {
      switch (status) {
        case 0:
          return {
            title: 'Active',
            code: status,
          };
        case 1:
          return {
            title: 'Submitted',
            code: status,
          };

        case 2:
          return {
            title: 'Approved',
            code: status,
          };

        case 3:
          return {
            title: 'Published',
            code: status,
          };

        case 4:
          return {
            title: 'Rejected',
            code: status,
          };

        case 5:
          return {
            title: 'Closed',
            code: status,
          };

        default:
          return {
            title: '',
            code: status,
          };
      }
    },
  },
};
